import { logEvent } from 'commons/utils/tracking';
import {
  ORDER_FILTER,
  ORDER_SEARCH,
  ORDER_TRANSACTION_ID_LINK_CLICK,
  ORDER_SELECT_BULK_LINK_CLICK,
  ORDER_METAFIELD_SAVE,
  ORDER_METAFIELD_FILTER,
  ORDER_METAFIELD_SAVE_ERROR,
  ORDER_METAFIELD_FILTER_ERROR,
  ORDER_LIST_EXPORT,
  ORDER_DRAFT_ORDER_CREATE,
  ORDER_LIST_FILTER_CLICK,
  ORDER_EDIT_CLICK,
  ORDER_EDIT_SAVE_CLICK,
  ORDER_EDIT_TRACKING_CODE_CLICK,
  ORDER_EDIT_TRACKING_CODE_SAVE_CLICK,
  ORDER_REOPEN_BUTTON_CLICK,
  ORDER_REOPEN_WITH_ISSUES_BUTTON_CLICK,
  DRAFT_ORDER_MARK_AS_PAID_BUTTON_CLICK,
  DRAFT_ORDER_WITH_STOCK_ISSUES_CONFIRM_BUTTON_CLICK,
  DRAFT_ORDER_WITH_STOCK_ISSUES_CANCEL_BUTTON_CLICK,
  DRAFT_ORDER_WITH_STOCK_ISSUES_UNDERSTOOD_BUTTON_CLICK,
  ORDER_DRAFT_ORDER_CREATE_BUTTON_CLICK,
  ORDER_QUICK_ACTION_CLICK,
  ORDER_BUTTON_MARK_AS_PAID_CLICK,
  ORDER_LIST_EXPORT_BUTTON_CLICK,
  ORDER_LIST_CREATE_DRAFT_ORDER_BUTTON_CLICK,
  ORDER_BUTTON_NOTIFY_SHIPPING,
  ORDER_BUTTON_COPY_SHIPPING_LINK,
  ORDER_SELECT_SAVED_SEARCH,
  ORDER_UNSELECT_SAVED_SEARCH,
  ORDER_FILTER_CHIP_CLOSE,
  ORDERS_CLEAR_FILTERS,
  ORDERS_LAST_PAGE_CLICK,
  ORDERS_NUVEMPAGO_NUDGES_CTA_ACTIVE,
  ORDERS_NUVEMPAGO_NUDGES_CTA_VIEW,
  ORDERS_NUVEMPAGO_NUDGES_CTA_CLOSE,
  ORDERS_NUVEMPAGO_NUDGES_CTA_CLICK_GROUP_3_ACTIVE,
  ORDERS_NUVEMPAGO_NUDGES_CTA_CLICK_GROUP_3_CLOSE,
  ORDERS_NUVEMPAGO_NUDGES_CTA_CLICK_GROUP_3_VIEW,
  ORDERS_NE_CLOSE_PROMOTION_BANNER,
  ORDERS_NE_VIEW_PROMOTION_BANNER,
  ORDERS_NE_ACCEPT_PROMOTION_BANNER,
  ORDERS_UNPACK_CLICK,
  ORDERS_UNPACK_CONFIRM,
  ORDERS_SEARCH_FILTER_CLICK,
  ORDERS_AUTO_CANCEL_BUTTON_CLICK,
  ORDERS_AUTO_CANCEL_PIX_CONFIGURATION_CLICK,
  ORDERS_AUTO_CANCEL_NUVEMPAGO_ACTIVATION,
  ORDERS_AUTO_CANCEL_SAVE_CONFIGURATION,
  ORDERS_STOCK_ISSUES_BUTTON_CLICK,
  ORDERS_STOCK_ISSUES_ALERT_DISMISS,
  ORDERS_STOCK_ISSUES_SHOW_ALERT,
  ORDER_ABANDONED_CART_SEND_WHATSAPP_CLICK,
  ORDERS_CHARGEBACK_ORDER_CLICK,
  ORDERS_CHARGEBACK_NUVEMPAGO_CLICK,
  ORDERS_CHARGEBACK_EXIT_BUTTON_CLICK,
  ORDERS_CHARGEBACK_DEADLINE_ORDER_CLICK,
  ORDERS_CHARGEBACK_DEADLINE_NUVEMPAGO_CLICK,
  ORDERS_CHARGEBACK_DEADLINE_EXIT_BUTTON_CLICK,
  ORDER_SAVED_SEARCH_QUICK_SAVE,
  ORDER_SAVED_SEARCH_QUICK_SAVE_RESULT,
  ORDER_SAVED_SEARCH_CONFIG_OPEN,
  ORDER_SAVED_SEARCH_CREATE,
  ORDER_SAVED_SEARCH_UPDATE,
  ORDER_SAVED_SEARCH_CONFIG_CONFIRM,
  ORDERS_AUTO_CANCEL_PROMOTIONAL_MODAL_ACTIVATE_CLICK,
  ORDER_SAVED_SEARCH_CREATE_UPSELL,
  ORDER_DETAILS_BUTTON_PRINT_LABEL,
} from 'config/trackingEvents';
import { UpsellResultEnum } from 'domains/Billing/UpsellFlow/hooks/useUpsellFlow';
import { NE_WELCOME_CREDIT_PROMOTION } from 'domains/NuvemEnvioCommons/constants';

type OrderFilterParams = {
  orderStatusFilter: string;
  dateRangeFilter: string;
  shippingStatusFilter: string[];
  shippingStatusFilterMultiselect: string;
  paymentStatusFilter: string[];
  paymentStatusFilterMultiselect: string;
  paymentMethodFilter: string;
  paymentProviderFilter: string;
  shippingFilter: string;
  channelFilter: string;
  applicationFilter: string;
  productsFilter: string;
  countSelectedProductsFilter: string;
  exactProductSetValue: string;
  productUnitsCountFilter: string;
  minUnitsFilter: string;
  maxUnitsFilter: string;
  couponIdsFilter: string;
};

type OrderExportFilterParams = {
  orderStatusFilter: string;
  dateFrom: string;
  dateTo: string;
  shippingStatusFilter: string[];
  paymentStatusFilter: string[];
  paymentMethodFilter: string;
  paymentProviderFilter: string;
  shippingFilter: string;
  channelFilter: string;
  applicationFilter: string;
  couponIdsFilter: string;
};

// ORDERS

export const trackingOrderFilter = (params: OrderFilterParams): void => {
  logEvent(ORDER_FILTER, {
    order_status_filter: params.orderStatusFilter,
    date_range_filter: params.dateRangeFilter,
    shipping_status_filter: params.shippingStatusFilter,
    shipping_status_filter_multiselect: params.shippingStatusFilterMultiselect,
    payment_status_filter: params.paymentStatusFilter,
    payment_status_filter_multiselect: params.paymentStatusFilterMultiselect,
    payment_method_filter: params.paymentMethodFilter,
    payment_provider_filter: params.paymentProviderFilter,
    shipping_filter: params.shippingFilter,
    channel_filter: params.channelFilter,
    application_filter: params.applicationFilter,
    products_filter: params.productsFilter,
    count_selected_variants: params.countSelectedProductsFilter,
    exact_product_set: params.exactProductSetValue,
    product_units_count_filter: params.productUnitsCountFilter,
    min_units_filter: params.minUnitsFilter,
    max_units_filter: params.maxUnitsFilter,
    coupon_ids_filter: params.couponIdsFilter,
  });
};

export const trackingOrderSearch = (textSearch: string) => {
  logEvent(ORDER_SEARCH, {
    input: textSearch,
    type: Number.isNaN(Number(textSearch)) ? 'string' : 'number',
  });
};

export const trackingTransactionLinkClick = (): void => {
  logEvent(ORDER_TRANSACTION_ID_LINK_CLICK, {});
};

export const trackingOrderBulkSelectClick = (ordersCount: number): void => {
  logEvent(ORDER_SELECT_BULK_LINK_CLICK, { bulkSize: String(ordersCount) });
};

export const trackingOrderMetafieldSave = (
  metafieldId: string,
  orderId: string,
  value: string | null,
): void => {
  logEvent(ORDER_METAFIELD_SAVE, {
    metafieldId,
    orderId,
    value: `${value}`,
  });
};

export const trackingOrderMetafieldSaveError = (
  metafieldId: string,
  orderId: string,
  value: string | null,
): void => {
  logEvent(ORDER_METAFIELD_SAVE_ERROR, {
    metafieldId,
    orderId,
    value: `${value}`,
  });
};

export const trackingOrderMetafieldFilter = (
  metafieldId: string,
  value: string,
): void => {
  logEvent(ORDER_METAFIELD_FILTER, {
    metafieldId,
    value,
  });
};

export const trackingOrderMetafieldFilterError = (): void => {
  logEvent(ORDER_METAFIELD_FILTER_ERROR, {});
};

export const trackingOrderListExport = (
  params: OrderExportFilterParams,
): void => {
  logEvent(ORDER_LIST_EXPORT, {
    order_status_filter: params.orderStatusFilter,
    date_from: params.dateFrom,
    date_to: params.dateTo,
    shipping_status_filter: params.shippingStatusFilter,
    payment_status_filter: params.paymentStatusFilter,
    payment_method_filter: params.paymentMethodFilter,
    payment_provider_filter: params.paymentProviderFilter,
    shipping_filter: params.shippingFilter,
    channel_filter: params.channelFilter,
    couponIdsFilter: params.couponIdsFilter,
    application_filter: params.applicationFilter,
  });
};

export const trackingOrderDraftOrderCreate = (
  paymentStatus: 'unpaid' | 'pending_confirmation' | 'paid',
): void => {
  logEvent(ORDER_DRAFT_ORDER_CREATE, {
    order_status: paymentStatus,
  });
};

export const trackingOrderDraftOrderCreateClick = (): void => {
  logEvent(ORDER_DRAFT_ORDER_CREATE_BUTTON_CLICK, {});
};

export const trackingOrderListFilterClick = (): void => {
  logEvent(ORDER_LIST_FILTER_CLICK, {});
};

export const trackingOrderListExportClick = (): void => {
  logEvent(ORDER_LIST_EXPORT_BUTTON_CLICK, {});
};

export const trackingOrderListCreateDraftOrderClick = (): void => {
  logEvent(ORDER_LIST_CREATE_DRAFT_ORDER_BUTTON_CLICK, {});
};

export const trackingOrderListQuickAction = (action: string): void => {
  logEvent(ORDER_QUICK_ACTION_CLICK, {
    action,
  });
};

export const trackingOrderEditClick = (
  upsellResult: UpsellResultEnum,
): void => {
  logEvent(ORDER_EDIT_CLICK, {
    upsell_result: upsellResult,
  });
};

export const trackingCreateSavedSearchUpsell = (
  upsellResult: UpsellResultEnum,
): void => {
  logEvent(ORDER_SAVED_SEARCH_CREATE_UPSELL, {
    upsell_result: upsellResult,
  });
};

export const trackingOrdersSearchFilterClick = (
  upsellResult: UpsellResultEnum,
  source: 'saved_searches' | 'filters' | 'search' | 'stock_issues',
  filter?: string,
): void => {
  logEvent(ORDERS_SEARCH_FILTER_CLICK, {
    source,
    ...(filter && { filter }),
    upsell_result: upsellResult,
  });
};

export const trackingOrderEditSaveClick = (
  reason: string | undefined,
  sendNotification: boolean,
  addedProductsQty: number,
  removedProductsQty: number,
  addsDiscounts: boolean,
  removesDiscounts: boolean,
): void => {
  logEvent(ORDER_EDIT_SAVE_CLICK, {
    reason: `${reason}`,
    sendNotification: `${sendNotification}`,
    addsProducts: `${addedProductsQty > 0}`,
    addedProductsQty: `${addedProductsQty}`,
    removesProducts: `${removedProductsQty > 0}`,
    removedProductsQty: `${removedProductsQty}`,
    addsDiscounts: `${addsDiscounts}`,
    removesDiscounts: `${removesDiscounts}`,
  });
};

export const trackingOrderEditTrackingCodeClick = (): void => {
  logEvent(ORDER_EDIT_TRACKING_CODE_CLICK, {});
};

export const trackingOrderEditTrackingCodeSaveClick = (
  sendNotification: boolean,
): void => {
  logEvent(ORDER_EDIT_TRACKING_CODE_SAVE_CLICK, {
    sendNotification: `${sendNotification}`,
  });
};

export const trackingOrderReopenButtonClick = (status: string): void => {
  logEvent(ORDER_REOPEN_BUTTON_CLICK, { order_status: status });
};

export const trackingOrderReopenWithIssuesButtonClick = (): void => {
  logEvent(ORDER_REOPEN_WITH_ISSUES_BUTTON_CLICK, {});
};

export const trackingOrderMarkAsPaidClick = (gatewayMethod?: string): void => {
  logEvent(
    ORDER_BUTTON_MARK_AS_PAID_CLICK,
    gatewayMethod ? { gatewayMethod } : {},
  );
};

export const trackingOrderNotifyShippingButtonClick = (
  trackingCode: boolean,
  notifyCustomer: boolean,
): void => {
  logEvent(ORDER_BUTTON_NOTIFY_SHIPPING, {
    trackingCode: `${trackingCode}`,
    notifyCustomer: `${notifyCustomer}`,
  });
};

export const trackingOrdersCopyShippingLinkButtonClick = (): void => {
  logEvent(ORDER_BUTTON_COPY_SHIPPING_LINK, {});
};
// DRAFT ORDERS

export const trackingDraftOrderMarkAsPaidButtonCLick = (): void => {
  logEvent(DRAFT_ORDER_MARK_AS_PAID_BUTTON_CLICK, {});
};
export const trackingDraftOrderConfirmWithIssuesButtonClick = (): void => {
  logEvent(DRAFT_ORDER_WITH_STOCK_ISSUES_CONFIRM_BUTTON_CLICK, {});
};
export const trackingDraftOrderCancelWithIssuesButtonClick = (): void => {
  logEvent(DRAFT_ORDER_WITH_STOCK_ISSUES_CANCEL_BUTTON_CLICK, {});
};
export const trackingDraftOrderWithIssuesUndestoodButtonClick = (): void => {
  logEvent(DRAFT_ORDER_WITH_STOCK_ISSUES_UNDERSTOOD_BUTTON_CLICK, {});
};

export const trackingSearchBySavedSearches = (
  savedSearchKey: string,
  isCustomSavedSearch: boolean,
  selected?: boolean,
) => {
  logEvent(selected ? ORDER_SELECT_SAVED_SEARCH : ORDER_UNSELECT_SAVED_SEARCH, {
    savedSearch: isCustomSavedSearch ? 'custom' : savedSearchKey,
    customSavedSearchKey: isCustomSavedSearch ? savedSearchKey : '',
    isCustom: isCustomSavedSearch ? 'true' : 'false',
  });
};

export const trackingCreateSavedSearch = () => {
  logEvent(ORDER_SAVED_SEARCH_CREATE, {});
};

export const trackingUpdateSavedSearch = () => {
  logEvent(ORDER_SAVED_SEARCH_UPDATE, {});
};

export const trackingConfigSavedSearches = () => {
  logEvent(ORDER_SAVED_SEARCH_CONFIG_CONFIRM, {});
};

export const trackingSavedSearchQuickSave = (
  source: 'filter_modal' | 'applied_filters',
) => {
  logEvent(ORDER_SAVED_SEARCH_QUICK_SAVE, {
    source,
  });
};

export const trackingSavedSearchQuickSaveResult = (
  status: 'confirmed' | 'cancelled',
) => {
  logEvent(ORDER_SAVED_SEARCH_QUICK_SAVE_RESULT, {
    result: status,
  });
};

export const trackingSavedSearchConfigOpen = () =>
  logEvent(ORDER_SAVED_SEARCH_CONFIG_OPEN, {});

export const trackingFilterChipClose = (): void => {
  logEvent(ORDER_FILTER_CHIP_CLOSE, {});
};

export const trackingClearFilters = () => {
  logEvent(ORDERS_CLEAR_FILTERS, {});
};

export const trackingLastPageClick = () => {
  logEvent(ORDERS_LAST_PAGE_CLICK, {});
};

export const trackingOrderUnpackClick = () => {
  logEvent(ORDERS_UNPACK_CLICK, {});
};

export const trackingOrderUnpackConfirm = () => {
  logEvent(ORDERS_UNPACK_CONFIRM, {});
};

export const trackingNuvemPagoNudgesCtaClose = (group: string): void => {
  logEvent(ORDERS_NUVEMPAGO_NUDGES_CTA_CLOSE, { group });
};

export const trackingNuvemPagoNudgesCtaActive = (group: string): void => {
  logEvent(ORDERS_NUVEMPAGO_NUDGES_CTA_ACTIVE, { group });
};

export const trackingNuvemPagoNudgesCtaView = (group: string): void => {
  logEvent(ORDERS_NUVEMPAGO_NUDGES_CTA_VIEW, { group });
};

export const trackingNuvemPagoNudgesCalloutClose = (group: string): void => {
  logEvent(ORDERS_NUVEMPAGO_NUDGES_CTA_CLICK_GROUP_3_CLOSE, { group });
};

export const trackingNuvemPagoNudgesCalloutActive = (group: string): void => {
  logEvent(ORDERS_NUVEMPAGO_NUDGES_CTA_CLICK_GROUP_3_ACTIVE, { group });
};

export const trackingNuvemPagoNudgesCalloutView = (group: string): void => {
  logEvent(ORDERS_NUVEMPAGO_NUDGES_CTA_CLICK_GROUP_3_VIEW, { group });
};

export const trackingOrderListNewCreditPromotionBannerClose = () => {
  logEvent(ORDERS_NE_CLOSE_PROMOTION_BANNER, {
    promotion: NE_WELCOME_CREDIT_PROMOTION,
  });
};

export const trackingOrderListNewCreditPromotionBannerView = () => {
  logEvent(ORDERS_NE_VIEW_PROMOTION_BANNER, {
    promotion: NE_WELCOME_CREDIT_PROMOTION,
  });
};

export const trackingOrderListNewCreditPromotionBannerAcceptClick = () => {
  logEvent(ORDERS_NE_ACCEPT_PROMOTION_BANNER, {
    promotion: NE_WELCOME_CREDIT_PROMOTION,
  });
};

export const trackingOrderListAutoCancelButtonClick = (isNPActive: boolean) => {
  logEvent(ORDERS_AUTO_CANCEL_BUTTON_CLICK, { isNPActive: `${isNPActive}` });
};

export const trackingOrdersAutoCancelPromotionalModalActivateClick = () => {
  logEvent(ORDERS_AUTO_CANCEL_PROMOTIONAL_MODAL_ACTIVATE_CLICK, {});
};

export const trackingOrdersAutoCancelSave = (
  configuration: Record<string, string>,
) => {
  logEvent(ORDERS_AUTO_CANCEL_SAVE_CONFIGURATION, configuration);
};

export const trackingOrdersAutoCancelPixConfigurationButtonClick = () => {
  logEvent(ORDERS_AUTO_CANCEL_PIX_CONFIGURATION_CLICK, {});
};

export const trackingOrdersAutoCancelNPActiveClick = () => {
  logEvent(ORDERS_AUTO_CANCEL_NUVEMPAGO_ACTIVATION, {});
};

export const trackingOrdersStockIssuesButtonClick = () => {
  logEvent(ORDERS_STOCK_ISSUES_BUTTON_CLICK, {});
};

export const trackingOrdersStockIssuesAlertDismiss = () => {
  logEvent(ORDERS_STOCK_ISSUES_ALERT_DISMISS, {});
};

export const trackingOrdersStockIssuesShowAlert = () => {
  logEvent(ORDERS_STOCK_ISSUES_SHOW_ALERT, {});
};

export const trackingOrderAbandonedCartSendWhatsappClick = (cartId: string) => {
  logEvent(ORDER_ABANDONED_CART_SEND_WHATSAPP_CLICK, { cartId });
};

export const trackingOrdersChargebackExitButtonClick = () => {
  logEvent(ORDERS_CHARGEBACK_EXIT_BUTTON_CLICK, {});
};

export const trackingOrdersChargebackOrderClick = () => {
  logEvent(ORDERS_CHARGEBACK_ORDER_CLICK, {});
};

export const trackingOrdersChargebackNuvemPagoClick = () => {
  logEvent(ORDERS_CHARGEBACK_NUVEMPAGO_CLICK, {});
};

export const trackingOrdersChargebackDeadlineExitButtonClick = () => {
  logEvent(ORDERS_CHARGEBACK_DEADLINE_EXIT_BUTTON_CLICK, {});
};

export const trackingOrdersChargebackDeadlineOrderClick = () => {
  logEvent(ORDERS_CHARGEBACK_DEADLINE_ORDER_CLICK, {});
};

export const trackingOrdersChargebackDeadlineNuvemPagoClick = () => {
  logEvent(ORDERS_CHARGEBACK_DEADLINE_NUVEMPAGO_CLICK, {});
};
export const trackingOrderDetailsButtonPrintLabelClick = (orderId: string) => {
  logEvent(ORDER_DETAILS_BUTTON_PRINT_LABEL, { orderId });
};
